import { ResponsiveView } from "../../singlegame/ResponsiveHelpers";
import { IInterval } from "../Context/Interval";
import { ISystemContext } from "../Context/SystemContext";
import { CreateElement, Log, Safe } from "../MyHelpers";
import { UnregisterPixi, RegisterPixi } from "../PixiDebug";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { Settings } from "../Settings";
import { FrontendErrorCode } from "../api";
import { service } from "../services";
import * as PIXI from 'pixi.js'


export class GameViewAppPixi  {
	protected logGroup: string = "GameViewEngineAppPixi";
	//public pixiContainercanvas: PIXI.Container[][] = [];
	//public pixiCanvas: PIXI.AnimatedSprite[][] = [];
	protected resid: ResourceIdentifier;	
	protected systemContext: ISystemContext = null;
	protected restoreWebGlInterval : IInterval = null;
    protected view : HTMLElement = null;
	protected gameName : string = null;
	protected fixScreens : number = 3; 

	public constructor(resid: ResourceIdentifier, systemContext: ISystemContext , gameName : string) {
		this.resid = resid.Add("GameViewEngineAppPixi");		
		this.systemContext = systemContext.CreateSubContext("GameViewEngineAppPixi");
		this.gameName = gameName;
		this.fixScreens =  Settings.ScreenHeight * Settings.Screens;	
		//if(Settings.Enable2plus1) this.fixScreens =  Settings.ScreenHeight * (Settings.Screens - 1);
        this.view = CreateElement("div", {
			classes: [`GameViewEngineAppPixi-SlotWindow-${gameName}`], style: {
				//display : "flex",
                width : "100%",
                height : this.fixScreens+"px",
                bottom : "0px",
                position : "absolute",
				zIndex : "1",
			}
		});

        this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, () => {
			let success = this.tryRecoverWebglContext();

			// success, stop timer
			if (!success)
			{
				this.recoverFailCount++;

				if (this.recoverFailCount == this.maxRecoverFailCount)
				{
				    void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
				}
			}
		});

	}

	protected app: PIXI.Application<HTMLCanvasElement> = null;
	public GetView(): HTMLElement  {
		return this.view;
	}

    public GetAppView(): PIXI.Application<HTMLCanvasElement>  {
		return this.app;
	}

	//update canvas render 
	public Update() {
		this.app?.ticker?.update();
	}

    protected created: boolean = false;
    public Destroy()
    {
        
        this.InternalDestroy();
        this.created = false;
		this.restoreWebGlInterval.Stop();
    }
	
	public GetResponsiveView():ResponsiveView
	{
		return null;
	}

	protected InternalDestroy() {

		if (!this.created)
		{
			Log.Debug(this.logGroup, `Destroy(): no app, not destroying anything`);
			return;
		}

		// Log.Debug(this.logGroup, `Destroy(): destroying`);

		// reset arrays
		//Safe(() => this.pixiCanvas = []);
		//Safe(() => this.pixiContainercanvas = []);
	
		if (this.app != null) {
            Safe(() => this.view.removeChild(this.app.view));
			Safe(() => this.app.view.removeEventListener('webglcontextlost', this.webglcontextlostInstance));
			Safe(() => this.app.destroy(true, { children: true }));
			Safe(() => UnregisterPixi(this.app, this.resid));
			Safe(() => {
				var currentContext = this.app.view.getContext("webgl");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});
			Safe(() => {
				var currentContext = this.app.view.getContext("webgl2");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});

			this.app = null;
		}

		this.OnDestroyCallback?.();
	}

    public Create()
    {
		if (this.created)
		{
			// already created
			return;
		}
		
        this.created = true;
		try
		{
        	this.InternalCreate();
		}
		catch (ex)
		{
			this.restoreWebGlInterval.Start();
		}
    }

	protected InternalCreate()
	{
		if (!this.created)
		{
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}
	
		this.app = new PIXI.Application<HTMLCanvasElement>({			
			width: Settings.ScreenWidth,
			height: this.fixScreens, 
			backgroundAlpha: 0,	
			resolution: 1,
    		//autoDensity: true,
    		antialias: true,
            //backgroundColor : "white"		             
            //forceCanvas: true
		});
		
		this.app.stage.accessibleChildren = true;
        this.app.stage.accessible = true
        this.app.stage.sortableChildren = true;
		//this.app.stage.interactive = true;
        this.app.stage.name = `GameViewEngineAppPixi-${this.gameName}`;
		RegisterPixi(this.app, this.resid);

		this.app.stop(); // use custom ticker	

        this.view.appendChild(this.app.view);

        this.app.view.style.bottom = "0px";
        this.app.view.style.position = "relative";
		this.app.view.style.overflow = "hidden";

		
		this.OnCreatedCallback?.();
	}

	protected recoverCount: number = 0;
	protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;

	protected async tryRecoverWebglContext(): Promise<boolean>
	{
		if (!this.created)
		{
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		console.log(this.resid.ID() + " trying to recover");
	    void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
		try
		{
		    await service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
			this.InternalDestroy();
		    await service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
		}
		catch (ex)
		{
		    await service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
		}

		try
		{
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
		    await service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
			this.InternalCreate();

			// all fine, stop timer
			this.restoreWebGlInterval.Stop();
            console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

		    await service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
		    await service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex)
		{
            console.log(this.resid.ID() + " error recovering", ex);

            // prevent spamming the backend
            if (this.recoverFailCount < this.maxRecoverFailCount)
            {
			    await service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

                if (ex.message.toLowerCase().includes("this browser does not support webgl"))
                {
                       await service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
                else
                {
                       await service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
            }
		}

		return false;
	};

	protected webglcontextlost()
	{
        Log.Error(this.logGroup, `Webgl context lost`);
	    void service.api.frontendError(FrontendErrorCode.WebGLContextLost, "Webgl context lost");

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success)
		{
			// all good
			return;
		}
		
		// error recovering, start timer
		this.restoreWebGlInterval.Start();
	}

    protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);
	public OnCreatedCallback: OnCreatedEngineAppPixiCallbackHandler = null;

	public OnDestroyCallback: OnDestroyEngineAppPixiCallbackHandler = null;
	
	public GetJackpotDisplayContainer():PIXI.Container{
		return null
	}
}

export type OnCreatedEngineAppPixiCallbackHandler = () => void;
export type OnDestroyEngineAppPixiCallbackHandler = () => void;